/*业主名下房源*/
export function getRoomsByMemberId(memberId) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/GetRoomsByMemberId',
        method: 'get',
        params: {memberId: memberId}
    });
}

export function relieveMemberFamilyEntity(data) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/RelieveMemberFamilyEntity',
        method: 'post',
        params: data
    });
}

export function getOwnersByRoomId(roomId) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/GetOwnersByRoomId',
        method: 'get',
        params: {roomId: roomId}
    });
}

/*获取车辆*/
export function getRoomOwnerCarsByRoomId(roomId) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/GetRoomOwnerCarsByRoomId',
        method: 'get',
        params: {roomId: roomId}
    });
}

export function createRoomOwnerCar(data = {}) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/CreateRoomOwnerCar',
        method: 'post',
        data: data
    });
}

export function deleteRoomOwnerCar(id) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/DeleteRoomOwnerCar',
        method: 'delete',
        params: {id: id}
    });
}

export function getEmergencyContactInfo(roomId) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/GetEmergencyContactInfo',
        method: 'get',
        params: {roomId: roomId}
    });
}

export function createEmergencyContact(data) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/CreateEmergencyContact',
        method: 'post',
        data: data
    });
}

export function getUnOwnerRoomMember(roomId) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/GetUnOwnerRoomMember',
        method: 'get',
        params: {roomId: roomId}
    });
}

export function roomCreateRoomMember(data) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/RoomCreateRoomMember',
        method: 'post',
        data: data
    });
}

export function getKeyDeliveryByRoomId(roomId) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/GetKeyDeliveryByRoomId',
        method: 'get',
        params: {roomId: roomId}
    });
}

export function saveKeyDelivery(data) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/SaveKeyDelivery',
        method: 'post',
        data: data
    });
}

/*签名成功*/
export function signSuccess(data) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/SignSuccess',
        method: 'post',
        data: data
    });
}

export function getDeliveryDataRecord(roomId,businessType) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/GetDeliveryDataRecord',
        method: 'get',
        params: {roomId: roomId,businessType:businessType}
    });
}

/*获取业主+家庭成员 关联房子*/
export function getOwnerAndFamilyRooms(memberId) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/GetOwnerAndFamilyRooms',
        method: 'get',
        params: {memberId: memberId}
    });
}
